import {
  // CustomAgGrid,
  gridConstants as gc,
  filters,
  filterParams,
  // extractValues,
  // lookupValue,
  // lookupKey
} from '../components/AgGrid/AgGrid';
import { DEFAULT_API_CONFIG } from '../services/apiConfig';
// SERVICES
import { getOrderReportPdf } from '../services';
import { orderLineStatusLookupCodes } from '../enums';
import { formatNumberWithCommas } from './functions';
import { pastDueLookUp } from '../enums';

const pdfColumnDef = {
  headerName: 'PDF',
  filter: false,
  // sortable: false,
  width: 150,
  // comparator: (valueA, valueB, nodeA, nodeB, isDescending) => (!!valueA.location ? -1 : valueB.location ? 1 : 0),
  // valueGetter: ({ data }) => {
  //   return !!data.location;
  // },
  // filter: filters.set,
  // filterParams: {
  //   values: ['Has PDF', 'Does not have PDF'],
  // },
  processCellCallback: cell => cell.value,
  cellRenderer: ({ data }, callerIsExport) => {
    if (callerIsExport) {
      return;
    }

    // catch in case the grid is infinite loading and loads blank rows
    if (!data) {
      return;
    }

    // create the container
    const div = document.createElement('div');
    div.style =
      'width: 100%; height: 100%; display: flex; flex-direction: row; justify-content: center; align-items: center;';

    const linkStyle =
      'margin: 0 5px; display: flex; flex-driection: column; justify-content: center; align-items: center;';
    const linkImageStyle = '';

    const onmouseenter = evt => (evt.target.style.opacity = 0.3);
    const onmouseleave = evt => (evt.target.style.opacity = ``);

    // check if a report is available (Location)
    const locationLink = document.createElement('a');
    locationLink.style = linkStyle;
    locationLink.href = data.location;
    locationLink.addEventListener('click', evt => {
      !data.location && evt.preventDefault();
      evt.stopPropagation();
    });

    const locationLinkImage = document.createElement('img');
    locationLinkImage.style = linkImageStyle;
    locationLinkImage.onmouseenter = onmouseenter;
    locationLinkImage.onmouseleave = onmouseleave;

    locationLinkImage.src = data.location
      ? '/assets/images/report_icon_25x25.png'
      : '/assets/images/report_unavailable_25x25.png';

    // append children elements
    locationLink.appendChild(locationLinkImage);
    div.appendChild(locationLink);

    // check if an insured report is available (insuredLocation)
    if (data.insuredLocation) {
      const insuredLocationLink = document.createElement('a');
      insuredLocationLink.style = linkStyle;
      insuredLocationLink.onmouseenter = onmouseenter;
      insuredLocationLink.onmouseleave = onmouseleave;

      insuredLocationLink.href = data.insuredLocation;
      insuredLocationLink.addEventListener('click', evt => {
        evt.stopPropagation();
      });

      const insuredLocationLinkImage = document.createElement('img');
      insuredLocationLinkImage.style = linkImageStyle;
      insuredLocationLinkImage.src = '/assets/images/insured_report_icon_25x25.png';

      // append children elements
      insuredLocationLink.appendChild(insuredLocationLinkImage);
      div.appendChild(insuredLocationLink);
    }

    return div;
  },
};

const printableOTColumnDef = {
  headerName: 'PDF',
  filter: false,
  sortable: false,
  width: 150,
  processCellCallback: cell => cell.value,
  // editable: false,
  cellRenderer: ({ data }, callerIsExport) => {
    if (callerIsExport) {
      return;
    }

    // catch in case the grid is infinite loading and loads blank rows
    if (!data) {
      return;
    }
    // create the container
    const div = document.createElement('div');
    div.style =
      'width: 100%; height: 100%; display: flex; flex-direction: row; justify-content: center; align-items: center;';

    const linkStyle =
      'margin: 0 5px; display: flex; flex-driection: column; justify-content: center; align-items: center;';
    const linkImageStyle = '';

    const onmouseenter = evt => (evt.target.style.opacity = 0.3);
    const onmouseleave = evt => (evt.target.style.opacity = ``);

    // check if a report is available (Location)
    const locationLink = document.createElement('a');
    locationLink.style = linkStyle;
    locationLink.href = `${DEFAULT_API_CONFIG.url}/inspector/orders/${data.orderTicket}/PrintOrderTicket`;
    //locationLink.setAttribute('target', '_blank');
    locationLink.addEventListener('click', evt => {
      // !data.location && evt.preventDefault();
      //evt.preventDefault();
      evt.stopPropagation();
    });

    const locationLinkImage = document.createElement('img');
    locationLinkImage.style = linkImageStyle;
    locationLinkImage.onmouseenter = onmouseenter;
    locationLinkImage.onmouseleave = onmouseleave;

    locationLinkImage.src = '/assets/images/report_icon_25x25.png';

    // append children elements
    locationLink.appendChild(locationLinkImage);
    div.appendChild(locationLink);

    return div;
  },
};

const coverageAColumnDef = {
  headerName: 'Coverage A',
  field: 'coverageA',
  filter: filters.number,
  valueFormatter: ({ value }) => {
    return `$${formatNumberWithCommas(value) || 0}`;
  },
};

const hazardScoreColumnDef = {
  headerName: 'Hazard Score',
  field: 'hazardScore',
  width: 155,
  filter: filters.number,
  cellRenderer: ({ value }) => {
    if (value == null || value === undefined) return '';
    const score = Number(value);
    let label, color, iconPath;
    if (score <= 25) {
      label = 'Acceptable'; color = '#4CAF50';
      iconPath = 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z';
    } else if (score <= 99) {
      label = 'Advisory'; color = '#FFC107';
      iconPath = 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z';
    } else if (score <= 499) {
      label = 'Required'; color = '#F44336';
      iconPath = 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z';
    } else {
      label = 'Critical'; color = '#9C27B0';
      iconPath = 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z';
    }
    const div = document.createElement('div');
    div.style = 'display:flex;align-items:center;gap:6px;height:100%;';
    div.innerHTML = '<svg viewBox="0 0 24 24" style="width:22px;height:22px;fill:' + color + '"><path d="' + iconPath + '"/></svg>' +
      '<span style="font-weight:600;">' + score + '</span>';
    div.title = label;
    return div;
  },
};

const closeoutColumnDef = {
  headerName: 'Closeout',
  field: 'cancelled',
  width: 125,
  minWidth: 125,
  suppressSizeToFit: true,
  filter: false,
  sortable: false,
  cellRenderer: ({ data }) => {
    if (!data || data.cancelled !== 'Yes') return '';
    const div = document.createElement('div');
    div.style = 'display:flex;align-items:center;justify-content:center;height:100%;';
    div.innerHTML = '<svg viewBox="0 0 24 24" style="width:24px;height:24px;fill:#000"><path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/></svg>';
    div.title = 'Cancelled';
    return div;
  },
};

const reviewedStatusColumnDef = {
  headerName: 'Reviewed Status',
  field: 'reviewedStatusName',
  width: 170,
  minWidth: 150,
  filter: filters.set,
  filterParams: {
    values: ['Needs Review', 'Processed'],
  },
  sortable: true,
};

const setupColumnDefs = (hasCheckbox = false) => {
  const colDefs = {
    // ADMIN
    admin: {
      admin: [
        {
          headerName: 'Order Ticket',
          field: 'orderTicket',
          enablePivot: true,
          cellRenderer: 'agGroupCellRenderer',
          aggFunc: 'count',
          enableValue: true,
          checkboxSelection: hasCheckbox,
          width: 250,
        },
        { headerName: 'Policy Number', field: 'policyPolicyNumber', width: 250 },
        {
          headerName: 'Report Name',
          field: 'reportName',
          filter: filters.text,
        },
        {
          headerName: 'Report Code',
          field: 'reportCode',
          filter: filters.text,
        },
        {
          headerName: 'Product Category',
          field: 'productCategoryName',
        },
        {
          headerName: 'Status Code',
          field: 'orderLineStatusLookupCode',
          filter: filters.set,
          filterParams: {
            values: Object.keys(orderLineStatusLookupCodes),
            filterLookup: orderLineStatusLookupCodes,
          },
          enablePivot: true,
        },
        {
          headerName: 'Status Description',
          field: 'orderLineStatusLookupDescription',
          filter: filters.text,
          enablePivot: true,
        },
        {
          headerName: 'Hold',
          field: 'onHold',
          filter: filters.text,
        },
        {
          headerName: "Hold Date",
          field: "holdDate",
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: "dateUTC",
          filter: filters.date,
          filterParams: filterParams.date,
        },
        {
          headerName: 'Needs Manual Assign',
          field: 'needsManualAssign',
          filter: filters.text,
        },
        {
          headerName: 'Order Date',
          field: 'orderDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },
        {
          headerName: 'Client Due Date',
          field: 'dueDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },
        {
          headerName: 'Inspector Due Date',
          field: 'fieldRepDueDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },
        {
          headerName: 'Inspector Schedule Date',
          field: 'appointmentDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        {
          headerName: 'Closed Date',
          field: 'closedDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },
        {
          headerName: 'Submitted to QA',
          field: 'submittedToQa',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },
        // { headerName: 'Agency Name', field: 'agencyName',filter: filters.text },
        // { headerName: 'Date of Last Call Attempt', field: 'dateLastCallAttempt', width: gc.DATE_FIELD_WIDTH, cellRenderer: 'dateUTC', filter: filters.date, filterParams: filterParams.date, },
        // { headerName: 'Special Instructions', field: 'specialInstructions', filter: filters.text, tooltipField: 'specialInstructions' },
        {
          headerName: 'Assigned QA',
          field: 'assignedQa',
          filter: filters.text,
          enablePivot: true,
        },
        {
          headerName: 'Days til due',
          field: 'daysUntilDue',
          filter: filters.number,
          /* cellStyle: data => {
            return data.value > 0 ? { color: 'black' } : { color: 'red' };
          }, */
        },
        {
          headerName: 'Past Due',
          field: 'pastDue',
          valueGetter: ({ data, ...rest }) => {
            // console.log({ data, rest })
            return data?.pastDue ? 'True' : 'False';
          },
          /* cellStyle: ({ value }) => {
            // console.log({value});
            return value === 'True' ? { color: 'red' } : { color: 'black' };
          }, */
          filter: filters.set,
          filterParams: {
            values: Object.keys(pastDueLookUp),
            filterLookup: pastDueLookUp,
          },
          boolean: true,
        },
        {
          headerName: 'Order Duration',
          field: 'orderDuration',
          filter: filters.number,
        },
        {
          headerName: 'Client Name',
          field: 'clientName',
          // field: "policy.client.name",
          enablePivot: true,
        },
        { headerName: 'Client Code', field: 'clientCode' },
        { headerName: 'Field Rep', field: 'fieldRepName' },
        {
          headerName: 'Field Rep Fee',
          field: 'fieldRepPay',
          filter: filters.number,
          valueFormatter: ({ value }) => {
            if (value == null || value === '' || value === undefined) return '';
            const n = Number(value);
            if (Number.isNaN(n)) return '';
            return `$${formatNumberWithCommas(n, 2)}`;
          },
        },
        {
          headerName: 'Last Call Attempt',
          field: 'dateLastCallAttempt',
          filter: filters.date,
          filterParams: filterParams.date,
          cellRenderer: 'dateUTC',
        },
        { headerName: 'Customer Ref #', field: 'customerReferenceNumber' },
        { headerName: 'Policy Holder', field: 'policyHolderName' },
        { headerName: 'Insured Phone', field: 'insuredPhone' },
        { headerName: 'Insured Email', field: 'insuredEmail' },
        { headerName: 'Field Manager', field: 'fieldManagerName' },
        { headerName: 'Address', field: 'policyHolderAddress' },
        // { headerName: "Address", field: "policyHolderAddress.ad1" },
        { headerName: 'City', field: 'policyHolderCity' },
        // { headerName: "City", field: "policyHolderAddress.city" },
        {
          headerName: 'State',
          field: 'policyHolderState',
          // field: "policyHolderAddress.st",
          filter: filters.text,
        },
        { headerName: 'Zip', field: 'policyHolderZip' },
        // { headerName: "Zip", field: "policyHolderAddress.zip" },
        { headerName: 'County', field: 'policyHolderCounty' },

        coverageAColumnDef,

        // { headerName: "County", field: "policyHolderAddress.county" },
        // { headerName: "Policy Number", field: "policy.policyNumber" },
        { headerName: 'Cancellation', field: 'cancelled' },
        { headerName: 'Returned', field: 'returned' },
        { headerName: 'Reason Category', field: 'cancellationReason' },
        { headerName: 'Agency Name', field: 'agencyName' },
        { headerName: 'Underwriter', field: 'underwriterName', filter: filters.text },
        { headerName: 'Special Instructions', field: 'specialInstructions', tooltipField: 'specialInstructions' },
        {
          headerName: 'In Queue for Export',
          field: 'inQueueForWebServiceExport',
          filter: filters.set,
          filterParams: {
            values: ['True', 'False'],
          },
          boolean: true,
        },
        {
          headerName: 'Last Export Date',
          field: 'lastWebServiceExport',
          filter: filters.date,
        },
        {
          headerName: 'Return Date',
          field: 'returnDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
        },
        { headerName: 'Return Reason', field: 'returnReason' },
        { headerName: 'Rush', field: 'rush' },
        //{ headerName: 'Rush Type', field: 'rushType' },
        { headerName: 'Tier Number', field: 'tierNumber' },
        { headerName: 'Image Count', field: 'photoCount', filter: filters.number },
        pdfColumnDef,
      ],
    },

    qa: {
      admin: [
        {
          headerName: 'Order Ticket',
          field: 'orderTicket',
          enablePivot: true,
          cellRenderer: 'agGroupCellRenderer',
          aggFunc: 'count',
          enableValue: true,
          checkboxSelection: hasCheckbox,
          width: 250,
        },
        // { headerName: 'Order #', field: 'orderTicket' },
        { headerName: 'Policy Number', field: 'policyPolicyNumber', width: 250 },
        {
          headerName: 'Report Name',
          field: 'reportName',
          filter: filters.text,
        },
        {
          headerName: 'Report Code',
          field: 'reportCode',
          filter: filters.text,
        },
        {
          headerName: 'Product Category',
          field: 'productCategoryName',
        },
        {
          headerName: 'Status Code',
          field: 'orderLineStatusLookupCode',
          filter: filters.set,
          filterParams: {
            values: Object.keys(orderLineStatusLookupCodes).filter(code => code.includes('QA-') || code.includes('CL-R')),
            filterLookup: orderLineStatusLookupCodes,
          },
          enablePivot: true,
        },
        {
          headerName: 'Assigned QA',
          field: 'assignedQa',
          filter: filters.text,
          enablePivot: true,
        },
        {
          headerName: 'Days til due',
          field: 'daysUntilDue',
          filter: filters.number,
          // cellStyle: data => {
          //   return data.value > 0 ? { color: 'black' } : { color: 'red' };
          // },
        },
        {
          headerName: 'Past Due',
          field: 'pastDue',
          valueGetter: ({ data, ...rest }) => {
            // console.log({ data, rest })
            return data?.pastDue ? 'True' : 'False';
          },
          // cellStyle: ({ value }) => {
          //   // console.log({value});
          //   return value === 'True' ? { color: 'red' } : { color: 'black' };
          // },
          filter: filters.set,
          filterParams: {
            values: Object.keys(pastDueLookUp),
            filterLookup: pastDueLookUp,
            // values: [1,2,3]
          },
          boolean: true,
          // rowClassRules: {
          //   'past-due': ({ data }) => data?.pastDue,
          // }
        },
        {
          headerName: 'Hold',
          field: 'onHold',
          filter: filters.text,
        },
        {
          headerName: 'Inspector Schedule Date',
          field: 'appointmentDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        {
          headerName: 'Submitted to QA',
          field: 'submittedToQa',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        {
          headerName: 'Due Date',
          field: 'dueDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        { headerName: 'Client', field: 'clientName' },
        { headerName: 'Client Code', field: 'clientCode' },
        { headerName: 'Field Rep', field: 'fieldRepName' },
        { headerName: 'Customer Ref #', field: 'customerReferenceNumber' },
        { headerName: 'Policy Holder', field: 'policyHolderName' },
        { headerName: 'Insured Phone', field: 'insuredPhone' },
        { headerName: 'Address', field: 'policyHolderAddress' },
        { headerName: 'City', field: 'policyHolderCity' },
        { headerName: 'State', field: 'policyHolderState' },
        { headerName: 'Zip', field: 'policyHolderZip' },

        coverageAColumnDef,

        { headerName: 'Cancellation', field: 'cancelled' },
        { headerName: 'Agency Name', field: 'agencyName' },
        { headerName: 'Underwriter', field: 'underwriterName', filter: filters.text },
        { headerName: 'Special Instructions', field: 'specialInstructions', tooltipField: 'specialInstructions' },
        {
          headerName: 'Return Date',
          field: 'returnDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
        },
        { headerName: 'Return Reason', field: 'returnReason' },
        { headerName: 'Tier Number', field: 'tierNumber' },
      ],
      fieldrep: [
        {
          headerName: 'Order Ticket',
          field: 'orderTicket',
          enablePivot: true,
          aggFunc: 'count',
          enableValue: true,
          // width: 250,
        },
        printableOTColumnDef,
        { headerName: 'Policy Number', field: 'policy.policyNumber', width: 250 },
        {
          headerName: 'Report',
          field: 'productName',
          filter: filters.text,
        },
        {
          headerName: 'Status Code',
          field: 'orderStatusCode',
          filter: filters.text,
        },
        {
          headerName: 'Due Date',
          field: 'dueDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        { headerName: 'Agency Name', field: 'agentName' },
        { headerName: 'Special Instructions', field: 'specialInstructions', tooltipField: 'specialInstructions' },
        { headerName: 'Last Call Attempt', field: 'dateLastCall', width: gc.DATE_FIELD_WIDTH, cellRenderer: 'dateUTC', filter: filters.date, filterParams: filterParams.date, },
        { headerName: 'Policy Holder', field: 'policyHolderName' },
        { headerName: 'Insured Phone', field: 'insuredPhone' },
        { headerName: 'Address', field: 'policyHolderAddress.ad1' },
        { headerName: 'City', field: 'policyHolderAddress.city' },
        { headerName: 'State', field: 'policyHolderAddress.st' },
        { headerName: 'Zip', field: 'policyHolderAddress.zip' },
        { headerName: 'Date Last Order Ticket Print', field: 'fieldRepLastPrint' },
      ],
    },

    fieldrep: {
      admin: [
        {
          headerName: 'Order Ticket',
          field: 'orderTicket',
          enablePivot: true,
          // cellRenderer: 'agGroupCellRenderer',
          aggFunc: 'count',
          enableValue: true,
          // checkboxSelection: hasCheckbox,
          width: 250,
        },
        // { headerName: 'Order #', field: 'orderTicket' },
        { headerName: 'Policy Number', field: 'policyPolicyNumber', width: 250 },
        { headerName: 'Client', field: 'clientName' },
        { headerName: 'Client Code', field: 'clientCode' },
        { headerName: 'Field Rep', field: 'fieldRepName' },
        {
          headerName: 'Report Code',
          field: 'reportCode',
          filter: filters.text,
        },
        {
          headerName: 'Product Category',
          field: 'productCategoryName',
        },
        {
          headerName: 'Status Code',
          field: 'orderLineStatusLookupCode',
          filter: 'agSetColumnFilter',
          filterParams: {
            values: ['FR-ASSIGNED', 'FR-ACCEPTED', 'FR-SCHEDULED'].sort(),
            filterLookup: orderLineStatusLookupCodes,
          },
          enablePivot: true,
        },
        { headerName: 'Date Last Order Ticket Print', field: 'fieldRepLastPrint' },
        { headerName: 'Days since service line modified date', field: 'daysSinceFRModifiedDate', width: 300 },
      ],
    },

    underwriter: {
      admin: [
        { field: 'underwriterId', hide: true, filter: filters.number },
        closeoutColumnDef,
        hazardScoreColumnDef,
        reviewedStatusColumnDef,
        { headerName: 'Policy Number', field: 'policyPolicyNumber', width: 250 },
        { headerName: 'Order #', field: 'orderTicket' },
        {
          headerName: 'Order Status', field: 'clientOrderStatus',
          filter: filters.set,
          filterParams: {
            values: ["In Field", "Assigned to Policyholder", "In QA", "Closed"],
          }
        },
        {
          headerName: 'Report Name',
          field: 'reportName',
          filter: filters.text,
        },
        { headerName: 'Policy Holder', field: 'policyHolderName' },
        { headerName: 'Insured Phone', field: 'insuredPhone' },
        { headerName: 'Address', field: 'policyHolderAddress' },
        { headerName: 'City', field: 'policyHolderCity' },
        { headerName: 'State', field: 'policyHolderState' },
        { headerName: 'Zip', field: 'policyHolderZip' },
        {
          headerName: 'Closed Date',
          field: 'closedDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },

        coverageAColumnDef,

        { headerName: 'Agency Name', field: 'agencyName' },
        { headerName: 'Agency Code', field: 'agencyCode' },
        { headerName: 'Underwriter', field: 'underwriterName', filter: filters.text },
        { field: 'reviewedStatusModifiedBy', hide: true, filter: filters.text },
        { headerName: 'Processed By', field: 'reviewedStatusModifiedByName', filter: filters.text },
        {
          headerName: 'Processed On', field: 'reviewedStatusModifiedOn',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        { headerName: 'Special Instructions', field: 'specialInstructions', tooltipField: 'specialInstructions' },
        pdfColumnDef,
      ],
    },

    qaTimeTracking: {
      admin: [
        { headerName: 'Product Code', field: 'productCode' },
        { headerName: 'Order Count', field: 'orderCount' },
        { headerName: 'Average Answers Changed', field: 'avgAnswersChanged', width: 230 },
        { headerName: 'Average Minutes to Complete', field: 'avgMinutesToComplete', width: 240 },
      ],
    },

    client: {
      all: [
        closeoutColumnDef,
        hazardScoreColumnDef,
        reviewedStatusColumnDef,
        pdfColumnDef,
        { headerName: 'Policy Number', field: 'policyPolicyNumber', width: 250 },
        { headerName: 'Order #', field: 'orderTicket' },
        {
          headerName: 'Order Status', field: 'clientOrderStatus',
          filter: filters.set,
          filterParams: {
            values: ["In Field", "Assigned to Policyholder", "In QA", "Closed"],
          }
        },
        { headerName: 'Report Name', field: 'reportName' },
        { headerName: 'Inspection Type', field: 'inspectionType' },
        { headerName: 'Program Code', field: 'programCode' },
        { headerName: 'Customer Ref #', field: 'customerReferenceNumber' },
        { headerName: 'Policy Holder', field: 'policyHolderName' },
        { headerName: 'Insured Phone', field: 'insuredPhone' },
        { headerName: 'Address', field: 'policyHolderAddress' },
        { headerName: 'City', field: 'policyHolderCity' },
        { headerName: 'State', field: 'policyHolderState' },
        { headerName: 'Zip', field: 'policyHolderZip' },
        {
          headerName: 'Order Date',
          field: 'orderDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        {
          headerName: 'Closed Date',
          field: 'closedDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },

        coverageAColumnDef,

        { headerName: 'Agency Name', field: 'agencyName' },
        { headerName: 'Agency Code', field: 'agencyCode' },
        { headerName: 'Underwriter', field: 'underwriterName', filter: filters.text },
        {
          headerName: 'Special Instructions',
          field: 'specialInstructions',
          tooltipField: 'specialInstructions',
        },
      ],
      closed: [
        closeoutColumnDef,
        hazardScoreColumnDef,
        reviewedStatusColumnDef,
        pdfColumnDef,
        { headerName: 'Policy Number', field: 'policyPolicyNumber', width: 250 },
        { headerName: 'Order #', field: 'orderTicket' },
        {
          headerName: 'Order Status', field: 'clientOrderStatus',
          filter: filters.set,
          filterParams: {
            values: ["In Field", "Assigned to Policyholder", "In QA", "Closed"],
          }
        },
        { headerName: 'Report Name', field: 'reportName' },
        { headerName: 'Inspection Type', field: 'inspectionType' },
        { headerName: 'Program Code', field: 'programCode' },
        { headerName: 'Customer Ref #', field: 'customerReferenceNumber' },
        { headerName: 'Policy Holder', field: 'policyHolderName' },
        { headerName: 'Insured Phone', field: 'insuredPhone' },
        { headerName: 'Address', field: 'policyHolderAddress' },
        { headerName: 'City', field: 'policyHolderCity' },
        { headerName: 'State', field: 'policyHolderState' },
        { headerName: 'Zip', field: 'policyHolderZip' },
        {
          headerName: 'Order Date',
          field: 'orderDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        {
          headerName: 'Closed Date',
          field: 'closedDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },

        coverageAColumnDef,

        { headerName: 'Agency Name', field: 'agencyName' },
        { headerName: 'Agency Code', field: 'agencyCode' },
        { headerName: 'Underwriter', field: 'underwriterName', filter: filters.text },
        {
          headerName: 'Special Instructions',
          field: 'specialInstructions',
          tooltipField: 'specialInstructions',
        },
      ],
      open: [
        closeoutColumnDef,
        hazardScoreColumnDef,
        reviewedStatusColumnDef,
        { headerName: 'Policy Number', field: 'policyPolicyNumber', width: 250 },
        { headerName: 'Order #', field: 'orderTicket' },
        {
          headerName: 'Order Status', field: 'clientOrderStatus',
          filter: filters.set,
          filterParams: {
            values: ["In Field", "Assigned to Policyholder", "In QA", "Closed"],
          }
        },
        { headerName: 'Report Name', field: 'reportName' },
        { headerName: 'Inspection Type', field: 'inspectionType' },
        { headerName: 'Program Code', field: 'programCode' },
        { headerName: 'Customer Ref #', field: 'customerReferenceNumber' },
        { headerName: 'Policy Holder', field: 'policyHolderName' },
        { headerName: 'Insured Phone', field: 'insuredPhone' },
        { headerName: 'Address', field: 'policyHolderAddress' },
        { headerName: 'City', field: 'policyHolderCity' },
        { headerName: 'State', field: 'policyHolderState' },
        { headerName: 'Zip', field: 'policyHolderZip' },
        {
          headerName: 'Order Date',
          field: 'orderDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
        },
        {
          headerName: 'Closed Date',
          field: 'closedDate',
          width: gc.DATE_FIELD_WIDTH,
          cellRenderer: 'dateUTC',
          filter: filters.date,
          filterParams: filterParams.date,
          enablePivot: true,
        },

        coverageAColumnDef,

        { headerName: 'Agency Name', field: 'agencyName' },
        { headerName: 'Agency Code', field: 'agencyCode' },
        { headerName: 'Underwriter', field: 'underwriterName', filter: filters.text },
        {
          headerName: 'Special Instructions',
          field: 'specialInstructions',
          tooltipField: 'specialInstructions',
        },
        pdfColumnDef,
      ],
    },
  };

  return colDefs;
};

export const getOrdersColumnDefinitions = (portal = 'admin', permissions = 'admin', hasCheckbox = false) => {
  // console.log(portal, permissions, hasCheckbox)
  const colDefs = setupColumnDefs(hasCheckbox);

  if (portal && permissions && colDefs[portal] && colDefs[portal][permissions]) {
    return colDefs[portal][permissions];
  }

  // default to returning the ADMIN column definitions
  return colDefs.admin;
};

// export default getOrdersColumnDefinitions;
